import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { useCreateFlow } from '@/hooks/vsl-dinamica/useDynamicFlows';
import { FlowNameDialog } from './FlowNameDialog';

interface CreateFlowDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function CreateFlowDialog({ open, onOpenChange }: CreateFlowDialogProps) {
  useLanguage();
  const navigate = useNavigate();
  const createFlow = useCreateFlow();

  const create = async (name: string) => {
    try {
      const flow = await createFlow.mutateAsync(name);
      onOpenChange(false);
      navigate(`/vsl-dinamica/${flow.id}`);
    } catch (error) {
      toast.error((error as Error).message || translateInterfaceText("Não foi possível criar o fluxo."));
    }
  };

  return (
    <FlowNameDialog
      open={open}
      onOpenChange={onOpenChange}
      title={translateInterfaceText("Criar fluxo")}
      description={translateInterfaceText("Depois você envia os vídeos e monta as etapas no editor.")}
      submitLabel={translateInterfaceText("Criar e abrir o editor")}
      pending={createFlow.isPending}
      onSubmit={create}
    />
  );
}
